import { ImageWindow } from './../share/model';
import { Vector2 } from 'three';
import { filter } from 'rxjs/operators';
import {
  Component,
  OnDestroy,
  OnInit,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { ImageState } from '../share/model';
import { initialImageTest2State } from '../../image-store/image-store.service';
import { fetchCommonValue } from '../share/utils';

@Component({
  selector: 'app-window',
  templateUrl: './window.component.html',
  styleUrls: ['./window.component.css'],
})

export class WindowComponent implements OnInit, OnDestroy {
  @Input()
  width: number | undefined = 1.0;
  @Output()
  widthChange = new EventEmitter<number>();
  @Input()
  level: number | undefined = 0.5;
  @Output()
  levelChange = new EventEmitter<number>();
  @Output()
  widthlevelChange = new EventEmitter<ImageWindow>();
  @Input()
  set related(images: ImageState[]) {
    this.setInputToDefault(images);
  }

  constructor() {}

  ngOnInit() {}

  ngOnDestroy(): void {}

  updateWidth(width: number | undefined) {
    this.width = width;
    if (this.width !== undefined) {
      this.widthChange.emit(this.width);
    }
  }
  updateLevel(level: number | undefined) {
    this.level = level;
    if (this.level !== undefined) {
      this.levelChange.emit(this.level);
    }
  }
  updateWidthLevel(width: number | undefined, level: number | undefined) {
  // updateWidthLevel(widthlevel: Vector2) {
    // this.width = widthlevel.x;
    // this.level = widthlevel.y;
    this.width = width;
    this.level = level;
    if (this.width && this.level !== undefined) {
      this.widthlevelChange.emit({width: this.width, level: this.level});
    }
  }

  public parse(source: string | undefined): number | undefined {
    return parseFloat(source);
  }
  private setInputToDefault(images: ImageState[]) {
    if (images.length === 0) {
      return;
    }
    this.updateWidth(
      fetchCommonValue(images, (s: ImageState) => s.filter.width),
    );
    this.updateLevel(
      fetchCommonValue(images, (s: ImageState) => s.filter.level),
    );
    this.updateWidthLevel(
      fetchCommonValue(images, (s: ImageState) => s.filter).width,
      fetchCommonValue(images, (s: ImageState) => s.filter).level
    );
  }
}
